import { jsx as _jsx } from "react/jsx-runtime";
import { AriaErrorIdContext, useOuterFieldAriaInvalidProps } from "./AriaErrorContext";
/**
 * Outer wrapper for composite fields: sets role="group" (overridable),
 * wires aria-errormessage / aria-invalid from Formik state, and resets
 * AriaErrorIdContext so the outer error id does not leak onto nested
 * inputs. Extra props are forwarded to the chosen `component`.
 */
export function AriaErrorScope({ form, fieldName, errorDisplay, component: Component, role = "group", children, ...rest }) {
    const ariaInvalidProps = useOuterFieldAriaInvalidProps(form.errors, form.touched, fieldName, errorDisplay);
    return (_jsx(AriaErrorIdContext.Provider, { value: undefined, children: _jsx(Component, { role: role, ...ariaInvalidProps, ...rest, children: children }) }));
}
//# sourceMappingURL=AriaErrorScope.js.map